import api from "./api"

import { upload } from './upload';

export const getNews = async (limit = null) => {
  let route = 'noticias';
  if (limit) route += `?LIMIT=${limit}`
  const news = await api.get(route);
  return news.data;
}

export const getNewsById = async (id) => {
  const news = await api.get(`noticias?ID=${id}`);
  return news.data;
}

export const register = async (notice) => {
  const news = await api.post('noticias', notice);
  return news.data;
}

export const update = async (id, notice) => {
  const news = await api.put(`noticias?ID=${id}`, notice);
  return news;
}

export const destroy = async (id) => {
  const news = await api.delete(`noticias?ID=${id}`);
  return news;
}

export const getAttachments = async (noticeId) => {
  const attachments = await api.get(`noticias/${noticeId}/anexos`);
  return attachments.data;
}

export const uploadAttachment = async (file, name, notice) => {
  const { url } = await upload(file);

  return await api.post(`noticias/${notice}/anexos`, {
    url,
    filename: name,
    mimetype: file.type,
  });
}